import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearActiveExperience(): RootActionTypes {
  return {
    type: ActionTypes.CLEAR_ACTIVE_EXPERIENCE,
  };
}
